import { useAuth } from "@/auth/Auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader/Loader";

export const Logout = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    signOut()
      .then(() => {
        navigate("/", { replace: true });
      })
      .catch((error) => {
        console.error(error);
        navigate("/", { replace: true });
      });
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      <Loader />
    </div>
  );
};
